<script>
  import { onMount } from 'svelte';
  export let imgSrc;
  export let mainDesc1 = '메인설명1';
  export let mainDesc2 = '메인설명2';
  export let subDesc1 = '서브설명1';
  export let subDesc2 = '서브설명2';

  // const activeOffset = 150;
  let innerHeight, innerWidth;
  let wrapper;
  let target1, target2, target3, target4, target5;

  function logAnim() {
    const targets = [target1, target2, target3, target4, target5];
    const boxTop = wrapper.getBoundingClientRect().top;

    if (boxTop < innerHeight * 0.55 && boxTop > innerHeight * 0.2) {
      targets.forEach((target) => target.classList.add('active'));
    } else {
      targets.forEach((target) => target.classList.remove('active'));
    }
  }
  onMount(() => {
    window.addEventListener('scroll', logAnim);
  });
</script>

<svelte:window bind:innerHeight bind:innerWidth />

<article class="log-container anim-target" bind:this={wrapper}>
  <div class="img-wrapper">
    <img
      class="log-img log-anim"
      src={imgSrc}
      alt="{mainDesc1} 사진"
      bind:this={target1}
    />
  </div>

  <span class="emph" />
  <div class="main-desc-wrapper">
    <div class="main-desc-1">
      <span class="curtain main1 log-anim" bind:this={target2} />{mainDesc1}
    </div>
    <br />
    <div class="main-desc-2">
      <span class="curtain main2 log-anim" bind:this={target3} />{mainDesc2}
    </div>
  </div>
  <div class="sub-desc-wrapper">
    <div class="sub-desc">
      <span class="fade-in log-anim" bind:this={target4} />{subDesc1}
    </div>
    <div class="sub-desc">
      <span class="fade-in log-anim" bind:this={target5} />{subDesc2}
    </div>
  </div>
</article>
<div class="css-keeper log-anim active log-img curtain fade-in" />

<style>
  .css-keeper {
    display: none;
  }

  .log-container {
    position: relative;
    width: 100%;
    height: 250px;
    overflow: hidden;
    z-index: 1;
  }

  .img-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .log-img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.3s;
    opacity: 0.8;
    z-index: 0;
  }

  @media screen and (min-width: 768px) {
    .log-container:hover .log-img {
      transform: scale(1.03);
      opacity: 1;
    }
    .log-container:hover .curtain {
      width: 100%;
    }
    .log-container:hover .fade-in {
      opacity: 1;
    }
  }

  .emph {
    position: absolute;
    top: 30px;
    left: 20px;
    width: 25px;
    border-top: 2px solid #fdb501;
    z-index: 1;
  }
  .main-desc-wrapper {
    position: absolute;
    top: 45px;
    left: 20px;
    z-index: 1;
    color: #f3f3f3;
  }
  .fade-in,
  .curtain {
    position: absolute;
    height: 100%;
    width: 0;
    top: 0;
    transition: 0.5s;
  }
  .curtain.main1 {
    background-color: rgba(3, 3, 3, 0.6);
    left: 0;
    z-index: -1;
  }
  .curtain.main2 {
    background-color: rgba(3, 3, 3, 0.3);
    z-index: -1;
    right: 0;
  }
  .fade-in {
    background-color: rgba(3, 3, 3, 0.3);
    opacity: 0;
    z-index: -1;
    width: 100%;
    /* right: 0; */
  }
  .main-desc-1 {
    position: relative;
    display: inline-block;
    margin: 0;
    font-weight: 400;
    font-size: 32px;
    /* text-decoration: underline; */
  }
  .main-desc-2 {
    position: relative;
    display: inline-block;
    margin: 0;
    font-weight: 300;
    font-size: 20px;
  }

  .sub-desc-wrapper {
    position: absolute;
    top: 180px;
    left: 20px;
    z-index: 1;
    color: #f3f3f3;
  }

  .sub-desc {
    margin: 0;
    font-weight: 100;
    font-size: 18px;
  }

  @media screen and (max-width: 768px) {
    .log-container {
      width: 100%;
    }
    .log-img {
      /* opacity: 0.5; */
    }

    .main-desc-1 {
      display: inline;
      font-size: 26px;
      /* background-color: rgba(3, 3, 3, 0.5); */
    }
    .main-desc-2 {
      font-weight: 300;
      /* background-color: rgba(3, 3, 3, 0.3); */
    }
    .sub-desc-wrapper {
      top: 170px;
      font-weight: 100;
      font-size: 16px;
      word-break: keep-all;
    }
    .sub-desc {
      /* display: inline; */
    }
    .sub-desc::before {
      content: ' ';
    }

    .active.log-img {
      transform: scale(1.03);
      opacity: 1;
    }
    .active.curtain {
      width: 100%;
    }
    .active.fade-in {
      opacity: 1;
    }
  }

  /* .log-anim {
    position: relative;
    opacity: 0;
    transition: 0.5s;
  }
  .log-anim:global(.active) {
    opacity: 1;
  }

  .active:global(.fade-bottom) {
    animation: fade-bottom 0.5s ease-in;
  }
  .active:global(.fade-left) {
    animation: fade-left 0.5s ease-in;
  }
  .active:global(.fade-right) {
    animation: fade-right 0.5s ease-in;
  }

  @keyframes fade-bottom {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes fade-left {
    0% {
      transform: translateX(-50px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes fade-right {
    0% {
      transform: translateX(50px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  } */
</style>
